import type { NonEmptyArray } from '@mntn-dev/utility-types'

import { levenshtein } from './levenshtein.ts'

export function closestMatch(
  target: string,
  candidates: NonEmptyArray<string>
): string {
  let closest = candidates[0]
  let minDistance = levenshtein(target, closest)

  for (let i = 1; i < candidates.length; i++) {
    const test = candidates[i] as string
    const distance = levenshtein(target, test)
    if (distance < minDistance) {
      closest = test
      minDistance = distance
    }
  }

  return closest
}
